import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import LoadingButton from '@mui/lab/LoadingButton';
import {Grid, Box, Button} from '@material-ui/core';
import {Switch, FormControlLabel } from '@mui/material';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import TextField from '@mui/material/TextField';
import axios from 'axios';
import {API_URL} from '../utils/EnvVars';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});


var vertical='top',horizontal='center';

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CustomizedDialogs = React.forwardRef((props, ref) => { 
  const [open, setOpen] = React.useState(false); 
  const [severityAlert, setSeverityAlert] = React.useState("error");
  const [showAlert, setShowAlert] = React.useState(false);
  const [alertMessage, setAlertMessage] = React.useState("");

  const [loadingBtn, setLoadingBtn] = React.useState(false);
  const [comment, setComment] = React.useState("");
  const [showToCustomer, setShowToCustomer] = React.useState(false);
  

  React.useImperativeHandle(ref, () => ({
    handleClickOpen(){
      setOpen(true);
    }
  }));
  
  const handleClose = () => {
    setOpen(false);
  };

  function hideAlert(){
		setShowAlert(false);
	}

  React.useEffect(() => {	
      setComment("");
      setShowToCustomer(false);
    
	}, [open]);
  


	function saveData(){
    if(!comment){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Enter comment");			
      return false;
    }

		if(comment){ 
			let axiosHeader = {
        headers: {
          'Content-Type': 'multipart/mixed',
          'device': 'web',
          'registerId': props.userObj.registerId,
          'uid': props.userObj.loginId,
          'fullName': props.userObj.fullName,
          'token': props.userObj.token,
        }
      };

      const data = new FormData();
      data.append('comment', comment);
      data.append('relatedTo', props.relatedTo);
      data.append('relatedToId', props.relatedToId);            

      if(showToCustomer===true){
        data.append('showToCustomer', 1);
      }else{
        data.append('showToCustomer', 0);
      }

      setLoadingBtn(true);
			axios.post(API_URL+'/crm-create-comments', data, axiosHeader)
			.then((response) => {
				setLoadingBtn(false);
        ///console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
				if(response.data.responseTxt==="success"){
          setSeverityAlert("success");
          setOpen(false);
					setShowAlert(true);
					setAlertMessage("Comment has been saved.");
          props.updatedList(response.data.list);	
					return false;
          
        }else if(response.data.responseTxt==="invalidtoken"){
            window.location.href='invalidtoken';

        }else{
          setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("Comment could not be saved.");			
					return false;
				}
			})
			.catch((error) => {
				  setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage(""+error);			
					return false;
			})	
		}		
	}

  
  return (
    <>
      <Dialog fullWidth maxWidth="md" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle style={{marginBottom:'-30px'}} onClose={handleClose}>Add Comment</DialogTitle>
          <DialogContent >
            <Grid item md={12} xs={12} >

                  <Box mt={2} mb={1} >
						        <Grid container spacing={2}>
                          
                          <Grid item md={12} xs={12} >
                              <TextField onChange={event => setComment(event.target.value)} value={comment} fullWidth variant="outlined" multiline rows={4} />
                          </Grid>

                          {props.showToCustomer===true?
                          <Grid item md={12} xs={12} >
                          <FormControlLabel
                                control={
                                  <Switch checked={showToCustomer} onChange={event => setShowToCustomer(event.target.checked)} />
                                }
                                label="Show to customer"
                              />
                          </Grid>
                          :null}

                    </Grid>
                  </Box>        

                  <Box mt={1} mb={1} >
						        <Grid container spacing={2}>
                          <Grid item md={12} xs={12} >
                            <Button onClick={() => {handleClose()}} style={{marginRight:12}} size="small" variant="outlined" >Cancel</Button>
                            {loadingBtn?
                            <LoadingButton
                              loading
                              loadingPosition="start"											
                              variant="outlined"
                              color="secondary"
                              id="waitloginbtnid" 
                              style={{width: 110, backgroundColor:'#008000',color:'#FFF',marginRight:10}}
                            >
                              Wait...
                            </LoadingButton>
                            :<Button onClick={() => {saveData()}} size="small" variant="contained" style={{backgroundColor:'#008000',color:'#FFF',marginRight:10}} >Save</Button>
                            }    
                          </Grid>
                    </Grid>
                  </Box>              

            </Grid>
          </DialogContent>
      </Dialog>
      
        <Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={16000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity={severityAlert} sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
				</Stack>


    </>
  );

});

export default CustomizedDialogs;